import { lazyCacheGetter } from './lazyCacheGetter';
const createNonActivatedVideoElement = () => {
    const element = document.createElement('video');
    element.dataset['activated'] = 'false';
    element.muted = true;
    return element;
};
/**
 * Return activated video element from cache if available,
 * otherwise create a new non-activated.
 * @returns
 */
export const getActivatedVideoElementIfAvailable = () => {
    return lazyCacheGetter().pop() || createNonActivatedVideoElement();
};
